import { redirect } from 'react-router-dom';

import { cookieJar } from '@consumer-frontend/nc-api';

import { resolveEntryRoute } from '../applyEntryRouting';

// Flag that lets us know if this is a refresh or direct url entry.
let hasHandledInitialLoad = false;

export const coldStartGuard = async ({ request }: { request: Request; }) => {
  if (hasHandledInitialLoad) { return; }

  hasHandledInitialLoad = true;

  const currentPath = new URL(request.url).pathname;
  const target = resolveEntryRoute(currentPath, !!cookieJar.getAccessToken());

  if (target && currentPath !== target) {
    throw redirect(target);
  }
};
